import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const ListingPopover = forwardRef((props, popover) => {
	const { mods, children, size } = props;

	let pos;
	let dir;

	if (Array.isArray(mods)) {
		mods.forEach((mod) => {
			if (mod.includes('pos')) pos = mod;
			if (mod.includes('dir')) dir = mod;
		});
	}

	if (typeof mods === 'string') {
		const modPos = mods.indexOf('pos');
		const dirPos = mods.indexOf('dir');

		if (modPos !== -1) pos = mods.slice(modPos, modPos + 4);
		if (dirPos !== -1) dir = mods.slice(dirPos, dirPos + 4);
	}

	return (
		<div
			className={cn(
				`ls-popover${pos && `-${pos}`}${dir && `-${dir}`}`,
				size,
			)}
			ref={popover}
		>
			<div className="ls-popover-content">{children}</div>
		</div>
	);
});

ListingPopover.propTypes = {
	/**
	 * Стилевые модификаторы
	 */
	mods: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.string),
		PropTypes.string,
	]),
	/**
	 * Дочерние элементы
	 */
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node,
	]),
	/**
	 *
	 */
	size: PropTypes.oneOf(['medium', 'small']),
};

ListingPopover.defaultProps = {
	mods: [],
	children: [],
	size: 'small',
};

export default ListingPopover;
